






















































































import Recruit, {IRecruit} from '@/models/Recruit'
import axios from 'axios'
import {apiV1AdminRecruitsPath, apiV1AdminUsersPath} from '@/rails/routes'
import {Component, Emit, Prop} from 'vue-property-decorator'
import Applicant from '@/models/Applicant'
import FormBase from "@/pages/form-base"
import User from "@/models/User"

@Component
export default class ApplicantForm extends FormBase {
  @Prop(Object) readonly value!: Applicant
  @Prop(Array) readonly resultItems!: Array<string>

  @Emit('input')
  input(value: Applicant): Applicant {
    return value
  }

  recruits: Array<Recruit> = []
  users: Array<User> = []
  years = [
    2021, 2020, 2019, 2018
  ]

  get internalValue(): Applicant {
    return this.value
  }

  set internalValue(val: Applicant) {
    this.input(val)
  }

  async mounted(): Promise<void> {
    await this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const recruits = await axios.get<Array<IRecruit>>(apiV1AdminRecruitsPath())
      this.recruits = recruits.data.map(r => new Recruit(r))
      const users = await axios.get(apiV1AdminUsersPath())
      this.users = users.data.list.map(r => new User(r))
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  public validate(): boolean {
    this.valid = (this.$refs.form as HTMLFormElement).validate()
    this.validated = true
    return this.valid
  }
}
